<template>
  <v-app>
    <v-app-bar app color="white" height="100">
      <v-avatar class="mr-3" color="grey lighten-5" size="70">
        <template
          v-if="$store.state.build_dealer_config === 'GlobalMediaHubli'"
        >
          <v-img
            contain
            max-height="70%"
            src="img/avatars/logoglobalmedia.jpeg"
            @click="openWebSite"
          ></v-img>
        </template>
        <template v-else>
          <v-img
            contain
            max-height="70%"
            src="img/avatars/logo.png"
            @click="openWebSite"
          ></v-img>
        </template>
      </v-avatar>
      <v-spacer> </v-spacer>
      <v-btn color="accent" text-color="white" x-large @click="launchLogin">
        Login
      </v-btn>
    </v-app-bar>

    <v-content>
      <section id="hero">
        <v-row no-gutters>
          <template v-if="$store.state.build_dealer_config === 'Chespik'">
            <v-img
              :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
              src="img/avatars/homepage-image1.jpeg"
            >
              <v-theme-provider dark>
                <v-container fill-height>
                  <v-row
                    align="center"
                    class="white--text mx-auto"
                    justify="center"
                  >
                    <v-col class="white--text text-center" cols="12" tag="h1">
                      <span
                        :class="[
                          $vuetify.breakpoint.smAndDown
                            ? 'display-1'
                            : 'display-2'
                        ]"
                        class="font-weight-light"
                      >
                        WELCOME TO
                      </span>
                      <br />
                      <span
                        :class="[
                          $vuetify.breakpoint.smAndDown
                            ? 'display-3'
                            : 'display-4'
                        ]"
                        class="font-weight-black"
                      >
                        CHESPIK
                      </span>
                      <span class="font-weight-black">
                        ...Generate Business Leads
                      </span>
                    </v-col>

                    <v-btn
                      class="align-self-end"
                      fab
                      outlined
                      @click="$vuetify.goTo('#about-me')"
                    >
                      <v-icon>mdi-chevron-double-down</v-icon>
                    </v-btn>
                  </v-row>
                </v-container>
              </v-theme-provider>
            </v-img>
          </template>
          <template v-else>
            <v-img
              :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
              src="img/avatars/GlobaMediaHubli_Background.jpg"
            ></v-img>
          </template>
        </v-row>
      </section>

      <section id="about-me">
        <div class="py-12"></div>

        <v-container class="text-center">
          <template v-if="$store.state.build_dealer_config === 'Chespik'">
            <h2 class="display-2 font-weight-bold mb-3">ABOUT CHESPIK</h2>
          </template>
          <template v-else>
            <h6 class="display-1 font-weight-bold mb-3">
              Digital Profile Card
            </h6>
          </template>

          <v-responsive class="mx-auto mb-8" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>
          <template v-if="$store.state.build_dealer_config === 'Chespik'">
            <v-responsive
              class="mx-auto title font-weight-light mb-8 align-self-end"
              max-width="720"
            >
              CHESPIK is the #1 digital profile card for Bussiness . The goal of
              the product is to provide businessmen or organisation with
              everything that is needed to build rich and engaging customer
              relationship. CHESPIK accomplishes that with a consistent profile
              update, Long-term Support (LTS), responsive community engagement,
              a vast database of business contacts and a dedication to quality
              components.
            </v-responsive>
          </template>
          <template v-else>
            <v-responsive
              class="mx-auto title font-weight-light mb-8 align-self-end"
              max-width="720"
            >
              GlobalMediaHubli-Digital Profile Card is the #1 digital profile
              card for Bussiness . The goal of the product is to provide
              businessmen or organisation with everything that is needed to
              build rich and engaging customer relationship.
              GlobalMediaHubli-Digital Profile Card accomplishes that with a
              consistent profile update, Long-term Support (LTS), responsive
              community engagement, a vast database of business contacts and a
              dedication to quality components.
            </v-responsive>
          </template>

          <v-avatar class="elevation-12 mb-12" size="128">
            <v-img src="img/avatars/Digitalvc.jpeg"></v-img>
          </v-avatar>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="features" class="grey lighten-3">
        <div class="py-12"></div>

        <v-container class="text-center">
          <template v-if="$store.state.build_dealer_config === 'Chespik'">
            <h2 class="display-2 font-weight-bold mb-3">CHESPIK FEATURES</h2>
          </template>
          <template v-else>
            <h6 class="display-1 font-weight-bold mb-3">
              Digital Profile Card Features
            </h6>
          </template>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ icon, title, text }, i) in features"
              :key="i"
              cols="12"
              md="4"
            >
              <v-card class="py-12 px-4" color="grey lighten-5" flat>
                <v-theme-provider dark>
                  <div>
                    <v-avatar color="primary" size="88">
                      <v-icon large v-text="icon"></v-icon>
                    </v-avatar>
                  </div>
                </v-theme-provider>

                <v-card-title
                  class="justify-center font-weight-black text-uppercase"
                  v-text="title"
                ></v-card-title>

                <v-card-text class="subtitle-1" v-text="text"> </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <section id="stats">
        <v-parallax
          :height="$vuetify.breakpoint.smAndDown ? 700 : 500"
          src="img/avatars/homepage-image2.jpeg"
        >
          <v-container fill-height>
            <v-row class="mx-auto">
              <v-col
                v-for="[value, title] of stats"
                :key="title"
                cols="12"
                md="3"
              >
                <div class="text-center">
                  <div
                    class="display-3 font-weight-black mb-4"
                    v-text="value"
                  ></div>

                  <div
                    class="title font-weight-regular text-uppercase"
                    v-text="title"
                  ></div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-parallax>
      </section>

      <section id="blog">
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-row>
            <v-col
              v-for="({ src, text, title }, i) in articles"
              :key="i"
              cols="12"
              md="4"
            >
              <v-img
                :src="src"
                class="mb-4"
                height="275"
                max-width="100%"
              ></v-img>

              <h3
                class="font-weight-black mb-4 text-uppercase"
                v-text="title"
              ></h3>

              <div class="title font-weight-light mb-5" v-text="text"></div>
            </v-col>
          </v-row>
        </v-container>

        <div class="py-12"></div>
      </section>

      <v-sheet id="contact" color="#333333" dark tag="section" tile>
        <div class="py-12"></div>

        <v-container>
          <h2
            class="display-2 font-weight-bold mb-3 text-uppercase text-center"
          >
            Contact Us
          </h2>

          <v-responsive class="mx-auto mb-12" width="56">
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

          <v-theme-provider light>
            <v-form>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="name"
                    flat
                    label="Name*"
                    :rules="nameRules"
                    required
                    solo
                  ></v-text-field>
                  <v-text-field
                    v-model="phonenumber"
                    flat
                    type="number"
                    label="Phone Number*"
                    :rules="phonenumberRules"
                    required
                    solo
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    flat
                    label="Email*"
                    :rules="emailRules"
                    required
                    solo
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="subject"
                    flat
                    label="Subject*"
                    :rules="subjectRules"
                    required
                    solo
                  ></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea
                    v-model="message"
                    flat
                    label="Message*"
                    :rules="messageRules"
                    required
                    solo
                  ></v-textarea>
                </v-col>

                <v-col class="mx-auto" cols="auto">
                  <v-btn color="accent" @click="sendMail" x-large>
                    Submit
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-theme-provider>
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-content>

    <template v-if="$store.state.build_dealer_config === 'Chespik'">
      <v-footer class="justify-center" color="#292929" height="100">
        <div
          class="title font-weight-light grey--text text--lighten-1 text-center"
        >
          &copy; {{ new Date().getFullYear() }} — FleeTOP Technologies <br />
          Contact : +91 6364887210/6364887211/6364887212 <br />
          Order : sales@fleetop.net
        </div>
      </v-footer>
    </template>
    <template v-else>
      <v-footer class="justify-center" color="#292929" height="100">
        <div
          class="title font-weight-light grey--text text--lighten-1 text-center"
        >
          &copy; {{ new Date().getFullYear() }} — Global Media Hubli <br />
          Contact : +91 9448706842/9845291048 <br />
          Order : globalmediahubli@gmail.com
        </div>
      </v-footer>
    </template>
  </v-app>
</template>

<script>
export default {
  name: "Home",

  data() {
    return {
      valid: false,
      name: null,
      phonenumber: null,
      subject: null,
      email: null,
      message: null,
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      phonenumberRules: [v => !!v || "Phonenumber is required"],
      subjectRules: [v => !!v || "Subject is required"],
      messageRules: [v => !!v || "Message is required"],
      nameRules: [v => !!v || "Name is required"],

      articles: [
        {
          src: "img/avatars/homepage-image3.jpeg",
          title: "Mobile first & Responsive",
          text:
            'A "Hands-On Guide" is exactly as it sounds , All relevant business leads can be genarated by sharing business profile though mobile apps'
        },
        {
          src: "img/avatars/homepage-image4.jpeg",
          title: "Think outside the box",
          text:
            "It contains complete businees details which can be used for digital markeing to advertise business profile & products ."
        },
        {
          src: "img/avatars/homepage-image5.jpeg",
          title: "Small changes, big difference",
          text:
            "Changing a habit for the better can change the trajectory of your business, Contact list is categorised to communicate business information among genuine contact list."
        }
      ],
      features: [
        {
          icon: "mdi-account-group-outline",
          title: "Vibrant Community",
          text:
            "Vibrant communities are the building blocks of our fast-paced business. To thrive, communities must be connected, We see communities as the foundations of a dynamic, interconnected network of business services."
        },
        {
          icon: "mdi-update",
          title: "Frequent Updates",
          text:
            "More frequenty updating business profile leads to persistent volatility of flows in and out of funds and to complex business dynamics"
        },
        {
          icon: "mdi-shield-outline",
          title: "Long-term Support",
          text:
            "Long-term support (LTS) is a product lifecycle management policy in which contact list is mantained for longer period of time"
        }
      ],
      procedures: [
        {
          icon: "mdi-account-group-outline",
          title: "Vibrant Community",
          text:
            "Vibrant communities are the building blocks of our fast-paced business. To thrive, communities must be connected, We see communities as the foundations of a dynamic, interconnected network of business services."
        },
        {
          icon: "mdi-update",
          title: "Frequent Updates",
          text:
            "More frequenty updating business profile leads to persistent volatility of flows in and out of funds and to complex business dynamics"
        },
        {
          icon: "mdi-shield-outline",
          title: "Long-term Support",
          text:
            "Long-term support (LTS) is a product lifecycle management policy in which contact list is mantained for longer period of time"
        }
      ],
      stats: [
        ["₹ 799 /-", "Annual Subscription"],
        ["Infinite", "Profile Updates"],
        ["Mobile App", "Store contact list"],
        ["Digital Marketing ", "Advertise Business Profile"]
      ]
    };
  },
  methods: {
    openWebSite() {
      if (this.$store.state.build_dealer_config === "Chespik") {
        window.open("https://www.fleetop.net");
      }
      if (this.$store.state.build_dealer_config === "GlobalMediaHubli") {
        window.open("https://www.globalmediahubli.com");
      }
    },
    launchLogin() {
      this.$router.push({ path: "/Login" });
    },
    sendMail() {
      this.validate();
      if (this.valid === true) {
        this.valid = false;

        this.$loadScript("https://smtpjs.com/v3/smtp.js")
          .then(() => {
            //this Promise return nothing!!!

            if (this.$store.state.build_dealer_config === "Chespik") {
              window.Email.send({
                SecureToken: "f871361d-6bdb-40e3-ad65-62bae4e6a77a", //generated from smtpJS website  working fleetop hostinger config
                /*  Host: 'smtp.hostinger.in',
               Username: 'prasanna@fleetop.net',
               Password: 'Fleetop@2019',
               Port: 587,*/
                To: "sales@fleetop.net",
                From: "prasanna@fleetop.net",
                Subject:
                  "CHESPIK Enquiry from " +
                  this.email +
                  " about " +
                  this.subject,
                Body:
                  "CHESPIK Contact no :" +
                  this.phonenumber +
                  "    Message Received : " +
                  this.message
              }).then(() => {
                alert(
                  "Thank You!! E-Mail Received..You will hear from us soon"
                );
                window.location.reload();
              });
            }
            if (this.$store.state.build_dealer_config === "GlobalMediaHubli") {
              window.Email &&
                window.Email.send({
                  /*    SecureToken: "fce22dfe-9c45-43cd-8e94-f8c1c47d720a", */
                  /*  Host: 'bh-in-9.webhostbox.net',
                Username: 'info@globalmediahubli.com',
                Password: 'Hubliinfo@964',
                Port: 465,
                UseSSL : YES
                Domain : globalmediahubli.com
                */

                  SecureToken: "94d8da42-78f8-4381-a61c-a7519047e2c6",

                  /*  Host: 'mail.globalmediahubli.com',
                Username: 'info@globalmediahubli.com',
                Password: 'Hubliinfo@964',
                Port: 587,
                UseSSL : NO
                Domain : globalmediahubli.com
                */

                  To: "globalmediahubli@gmail.com",
                  From: "info@globalmediahubli.com",
                  Subject:
                    "GlobalMediaHubli-Digital Profile Card Enquiry from " +
                    this.email +
                    " about " +
                    this.subject,
                  Body:
                    "GlobalMediaHubli-Digital Profile Card Contact no :" +
                    this.phonenumber +
                    "    Message Received : " +
                    this.message
                }).then(() => {
                  alert(
                    "Thank You!! E-Mail Received..You will hear from us soon"
                  );
                  window.location.reload();
                });
            }
          })
          .catch(() => {
            // Failed to fetch script
          });
      }
    },
    validate() {
      if (
        this.name !== null &&
        this.email !== null &&
        this.subject !== null &&
        this.message !== null &&
        this.phonenumber !== null
      ) {
        this.valid = true;
        return this.valid;
      } else {
        this.valid = false;
        alert("Please input all mandatory fields marked as *");
        return this.valid;
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>
